<template>
  <div>
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <br/>
        <!-- 新規お申込みボタン -->
        <v-row>
          <v-col cols="12">
            <v-btn x-large color="warning" dark min-width="320px" min-height="80px" elevation="20" :to="{name:'MBR400'}" class="bg-btn">申込みをはじめる</v-btn>
          </v-col>
        </v-row>
        <v-row style="margin-top:0px;">
          <v-col cols="4" sm="4" md="4" lg="4" xl="3" class="py-0">
           <v-card class="ml-auto" max-width="100px" color="transparent" flat>
              <v-img src="../assets/img/tqsman-big.png"></v-img>
            </v-card>
          </v-col>
          <v-col cols="8" sm="5" md="4" lg="4" xl="4" class="d-flex justify-start pt-1 pb-1">
            <p  class="speech-bg">お申込みをされる際は<br />こちらのボタンをクリックしてください。</p>
          </v-col>
        </v-row>

        <!-- お申込み履歴エリア -->
        <v-data-table
          dense
          :headers="headers"
          :items="desserts"
          :loading="datatableLoading" 
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 v-dtbl-body-md-1 elevation-1"
          :no-data-text="$t('webmsg.mbr100.datatblenodata')"
        >
          <template v-slot:[`item.progress`]="{ item }">
            <template v-if="item.progress.name != null && item.progress.name != ''">
            <v-chip :color="item.progress.color" text-color="white" v-if="item.progress.name != null && item.progress.name != ''">
              <v-icon left>{{ item.progress.icon }}</v-icon>
              {{ item.progress.name }}
            </v-chip>
            </template>
          </template>
          <template v-slot:[`item.plan`]="{ item }">
            <!-- <div class="text-caption text-sm-h6">
            {{ item.basePlanName }}
            <span v-if="item.optionPlanName != null" >
              <br/>
              {{ item.optionPlanName }}
            </span>
            {{ item.planName }}
            </div> -->
            <span v-html="item.planName" class="text-caption text-sm-subtitle-1"></span>
          </template>
          <template v-slot:[`item.confirmBtnFlg`]="{ item }">
            <span v-if="item.confirmBtnFlg">
              <v-btn medium color="warning" dark min-width="140px" @click="transScreenInputRequestHome(item.requestNo)">確認</v-btn>
            </span>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from '../common/utils';
export default {
  name: "MemberHome",
  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "ホーム",
      screenId: "MBR100",
      messageArea: "",
      datatableLoading: false,
      headers: [
          { text: '', align: 'center', sortable: false, value: 'progress', width: "1%" },
          { text: '申込番号', align: 'center', sortable: true, value: 'requestNo'},
          { text: '申込日時', align: 'center', sortable: true, value: 'requesdate'},
          { text: 'プラン', align: 'start', sortable: false, value: 'plan'},
          { text: '詳細', align: 'center', sortable: false, value: 'confirmBtnFlg'},
      ],
      desserts: [],
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
          this.$router.push(this.$router.resolve({ name: 'MBA100'}).href);
        },
      },
    };
  },
  mounted() {
    this.addHandler();
  },
  created() {
    this.initialize();
  },
  // destroyed() {
  //   this.removeHandler();
  // },
  methods: {
    addHandler: function () {
        window.addEventListener('popstate', this.browserHistoryBack);
    },
    removeHandler() {
        window.removeEventListener('popstate', this.browserHistoryBack);
    },
    browserHistoryBack() {
      this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
    },
   /*
    * 初期表示
    */
    initialize: function () {
      this.$store.commit("requestRegInfo/resetState");
      this.messageArea = this.$i18n.t('webmsg.mbr100.area');
      this.getRequestList();
    },

   /*
    * 申込一覧確認ボタン押下
    */
    transScreenInputRequestHome: function(selectedRequestNo) {
      // let paramRequestNo = Utils.removeChar(selectedRequestNo, '-');
      this.$router.push(this.$router.resolve({ name: "MBR500", params: {requestNo: selectedRequestNo, srcScreenId: this.screenId} }).href);
    },

   /*
    * 申込一覧取得
    */
    getRequestList : async function() {
      this.datatableLoading = true;
      // ログインサービス呼び出し
      let apiurl = Constants.getUrlApiMBR100G01("0");
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        this.displyRequestList(response.data);
        this.setAuthUserInfo(response.data);
        let result = this.setInitializeInfo(response.data);
        if (!result) {
          this.dlgMsg.msg = response.data.message;
          this.dlgMsg.isOpen = true;
        }
        this.dispProgress();
      } catch(error) {
        // if (this.$axios.isAxiosError(error) && error.response) {
          console.log(error.response.data);
        // }
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['お申込一覧']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      } finally {
        this.datatableLoading = false;
      }
    },
    /*
    * 申込一覧表示
    */
    displyRequestList : function(responseData) {
      this.desserts = new Array();
      if (responseData == null) {
        return;
      }
      let searchResultList = responseData.data.memberRequestList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      }
      let request;
      for (const value of searchResultList) {
        request = {};
        let progress = {};
        progress['cd'] = value.latestProgressClass;
        progress['name'] = value.progressName;
        request['progress'] = progress;
        request['requestNo'] = value.displayRequestNo;
        request['requesdate'] = value.displayRequestDatetime;
        // request['basePlanName'] = value.displayBasePlanName;
        // request['optionPlanName'] = value.displayOptionPlanName;
        request['planName'] = Utils.nl2br(value.displayPlanName);
        request['confirmBtnFlg'] = value.confirmFlg; 
        this.desserts.push(request);
      }
    },

    /*
    * マスタデータストア
    * データセット
    */
   setInitializeInfo: function(responseDto) {
      let retVal = false;
      if (responseDto == null) {
        return retVal;
      }
      let responseStatus = responseDto.statusCd;
      if (responseStatus !== 200) {
        return retVal;
      }
      retVal = true;
      // 区分マスタ（進捗区分）セット
      this.$store.dispatch("master/setProgressKbnList", responseDto.data.progressKbnList);   

      return retVal;
   },

    /*
    * 進捗区分画面表示
    */
    dispProgress : function() {
      this.progressKbnMstList = this.$store.getters["master/getProgressKbnList"];
      if (this.desserts == null || this.progressKbnMstList == null) {
          return;
      }
      this.desserts.forEach((dessert, index, arr) => {
        if (dessert.progress.cd != null && dessert.progress.cd != '') {
          let progresData = this.getProgressNm(dessert.progress.cd);
          if (progresData != null) {
            arr[index].progress.name = progresData.nameAbbr;
            arr[index].progress.color = progresData.value2;
            arr[index].progress.icon = progresData.value3;
          }
        }
      });

    },

     /**
     * 区分値（進捗）設定
     */
    getProgressNm(progressCd) {
      let retVal = "";
      let searchArry = "";
      if (progressCd != "") {
        searchArry = this.progressKbnMstList.find((v) => v.value1 === progressCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },    

    /*
    * 認証情報設定
    */
    setAuthUserInfo : function(responseData) {
      let loginUserInfo = responseData.data.loginUserInfo;
      this.$store.dispatch("authcUser/setLoggedUserInfo", {id: loginUserInfo.id, name:loginUserInfo.name, companyname:loginUserInfo.companyname});
      this.username = loginUserInfo.name;
      this.companyname = loginUserInfo.companyname;
    },
  },
};
</script>

<style scoped>
.bg-btn {
  font-size: x-large;
}

</style>
